import { ValuesEnum } from "../../../../../types/robot/IRobotEnums";

export const MapIndexToValues = (selectedIndex: number | null) => {
  let result = ValuesEnum.From0To150000;
  if (selectedIndex === 1) result = ValuesEnum.From150000To500000;
  else if (selectedIndex === 2) result = ValuesEnum.MoreThan500000;
  return result;
};

export const MapValuesToIndex = (values: ValuesEnum | null) => {
  if (values === ValuesEnum.From0To150000) return 0;
  if (values === ValuesEnum.From150000To500000) return 1;
  if (values === ValuesEnum.MoreThan500000) return 2;
  return null;
};
